import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {NewDocumentService} from '../../services/new-document.service';
import {ModalController} from '@ionic/angular';
import {GeneralService} from '../../services/general.service';
import {DocumentTypes} from '../../definitions/document-types';
import {StateManagerService} from '../../services/state-manager.service';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {CollectionsNames} from '../../definitions/collections-names';
import {ObservablesService} from '../../services/observables.service';
import {DetailLinesToBeCollectedComponent} from '../detail-lines-to-be-collected/detail-lines-to-be-collected.component';
import {PicturesPermissionService} from '../../services/pictures-permission.service';
import {CheckWardHealthCareComponent} from '../healthcare/check-ward/check-ward-health-care.component';
import {ConfigurationModel} from '../../models/configuration.model';
import {BufferedStockConciliationComponent} from '../healthcare/buffered-stock-conciliation/buffered-stock-conciliation.component';
import {CheckHospitalStockComponent} from '../healthcare/check-hospital-stock/check-hospital-stock.component';
import {SelectCurrentCustomerService} from '../../services/select-current-customer.service';

@Component({
    selector: 'app-document-type-modal',
    templateUrl: './document-type-modal.page.html',
    styleUrls: ['./document-type-modal.page.scss'],
})
export class DocumentTypeModalPage implements OnInit {

    @Input() docTypes: any;
    document: DocumentModel;
    mobileConfiguration: MobileConfigurationModel;
    configuration: ConfigurationModel;

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private generalServices: GeneralService,
                private docTypesDefinition: DocumentTypes,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private observables: ObservablesService,
                private picturesPermission: PicturesPermissionService,
                private selectCurrentCustomerService: SelectCurrentCustomerService) {
    }

    ngOnInit() {
        this.mobileConfiguration = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        this.configuration = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
    }

    async newDocument(docType: number) {
        console.log('docType', docType);
        if (docType === this.docTypesDefinition.SIGNDOCUMENT) {
            this.document = new DocumentModel();
        } else if (docType === this.docTypesDefinition.SERVICEJOB) {
            this.document = this.newDocumentService.buildServiceJobDocumentBean(this.newDocumentService.buildNewServiceJobObj());
        } else {
            this.document = this.newDocumentService.genNewDocument();
        }
        this.document.signLater = false;
        this.document.documentType = docType;
        console.log(this.document);
        await this.modalController.dismiss(this.document);
    }

    async scanBarcode(index: number) {
        let component;
        if (index === 1) {
            // TODO refactor to native scanner
            component = DetailLinesToBeCollectedComponent;
        } else if (index === 2) {
            component = CheckWardHealthCareComponent;
        } else if (index === 3) {
            component = BufferedStockConciliationComponent;
        } else if (index === 4) {
            component = CheckHospitalStockComponent;
        }
        await this.modalController.dismiss();
        await this.picturesPermission.checkPermissions();
        const modal = await this.modalController.create({
            component: component,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {}
        });
        modal.onDidDismiss().then(() => {
            console.log('Modal dismissed');
            this.observables.sendLoadDocsFlag();
        });
        return await modal.present();
    }

    selectCurrentCustomer() {
        this.selectCurrentCustomerService.assignCurrentCustomer();
    }
}
